import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import ThetaSwiper from './ThetaSwiper';
import "./plugin.css";
import "./swiper.min.css";
import classNames from 'classnames';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  
});

class ThetaImageMenu extends React.Component {
  state = {
    open: false,
    select: undefined
  };

  updateState(state){
    this.setState(state);
    //親コンポーネントを更新
    this.props.updateState(state);
  }

  selectClick = (preSelect, select, open) => {
    if (preSelect === select && open) {
      open = false
    } else if (!open) {
      open = true;
    }
    this.setState({ 
      select: select, 
      open: open
    });
  };
  
    render() {
    const { options,disabled,devicename } = this.props;
    const { select,open } = this.state;

    let version = devicename.substr(5,2);
    let optionDisabled = disabled;
    if(options.captureMode === 'video') {
        optionDisabled = true;
    }

    let _options = undefined;
    if (options.captureMode === 'image') {
        _options = options.image;
    } else {
        _options = options.video;
    }
    
    return (
        <div>
        {(() => {
            return (
            <div>
             
             {// eslint-disable-next-line 
             _options.exposureProgram == '2' && 
                 <div>
                 {select === 'ev' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position2_1')} id="ev_menu">
                  <ThetaSwiper select={`${select}`} options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'filter' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position2_2')} id="option_menu">
                  <ThetaSwiper select={`${select}`} options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting','pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                   <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="ev" data-position="2_1" onClick={() => {this.selectClick(select, 'ev',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>EV</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.auto.exposureCompensation}`}
                        </p>
                    </p>
                    </div>
                   </button>
                   <button disabled={optionDisabled} className={classNames('btn','btn--data')} data-setting="option" data-position="2_2"  onClick={() => {this.selectClick(select, 'filter',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>OptionSetting</p>
                    <p className={classNames('btn--data__value')} id="filterlavel1">
                        <p className={classNames('btn--data__value')}>
                            {`${_options.auto._filterText}`}
                        </p>
                    </p>
                    </div>
                   </button>
                </div>
             </div>}
             {// eslint-disable-next-line 
             _options.exposureProgram == '3' && 
                 <div>
                 {select === 'aperture' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_1')} id="ap_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'wb' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_2')} id="wb_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'ev' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_3')} id="ev_menu">
                  <ThetaSwiper select={`${select}`} options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting','pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="shutter" data-position="3_1"  onClick={() => {this.selectClick(select, 'aperture',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>apature</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${'F' + _options.aperture.aperture}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="wb" data-position="3_2" onClick={() => {this.selectClick(select, 'wb',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>WB</p>
                    <p className={classNames('btn--data__value--icon')} id="wblabel0">
                    <p className={classNames('btn--data__value--icon',`${_options.aperture.whiteBalanceIcon}`)}>
                        {`${_options.aperture.whiteBalance}`}
                    </p>
                    </p>
                    </div>
                  </button>
                   <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="ev" data-position="3_3" onClick={() => {this.selectClick(select, 'ev',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>EV</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.aperture.exposureCompensation}`}
                        </p>
                    </p>
                    </div>
                   </button>
                </div>
             </div>}
             {// eslint-disable-next-line
             _options.exposureProgram == '4' && 
                <div>
                 {select === 'shutterspeedSMode' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_1')} id="sp_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'ev' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_2')} id="ev_menu">
                  <ThetaSwiper select={`${select}`} options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'wb' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_3')} id="wb_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="shutter" data-position="3_1"  onClick={() => {this.selectClick(select, 'shutterspeedSMode',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ShutterSpeed</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.shutter.shutterSpeedText}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="ev" data-position="3_2"  onClick={() => {this.selectClick(select, 'ev',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>EV</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.shutter.exposureCompensation}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="wb" data-position="3_3" onClick={() => {this.selectClick(select, 'wb',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>WB</p>
                    <p className={classNames('btn--data__value--icon')} id="wblabel0">
                    <p className={classNames('btn--data__value--icon',`${_options.shutter.whiteBalanceIcon}`)}>
                        {`${_options.shutter.whiteBalance}`}
                    </p>
                    </p>
                    </div>
                  </button>
                </div>
             </div>}
             {// eslint-disable-next-line
             _options.exposureProgram == '9' && 
             <div>
                 {select === 'iso' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail', 'show','position3_1')} id="iso_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)} />
                  </div>
                 }
                 {select === 'ev' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail', 'show','position3_1')} id="ev_menu">
                  <ThetaSwiper select={`${select}`} options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'wb' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail', 'show','position3_1')} id="wb_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)} />
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting', 'pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="iso" data-position="3_1" onClick={() => {this.selectClick(select, 'iso',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ISO</p>
                    <p className={classNames('btn--data__value')} id="wbvlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.iso.iso}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="ev" data-position="3_2"  onClick={() => {this.selectClick(select, 'ev',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>EV</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.iso.exposureCompensation}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="wb" data-position="3_3"  onClick={() => {this.selectClick(select, 'wb',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>WB</p>
                    <p className={classNames('btn--data__value--icon')} id="wblabel0">
                    <p className={classNames('btn--data__value--icon',`${_options.iso.whiteBalanceIcon}`)}>
                        {`${_options.iso.whiteBalance}`}
                    </p>
                    </p>
                    </div>
                  </button>
                </div>
             </div>}
             {// eslint-disable-next-line
             _options.exposureProgram == '1' && version == 'YL' &&
             <div>
                 {select === 'iso' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_1')} id="iso_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)} />
                  </div>
                 }
                 {select === 'shutterspeed' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_2')} id="sp_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'wb' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position3_3')} id="wb_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting','pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="iso" data-position="3_1" onClick={() => {this.selectClick(select, 'iso',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ISO</p>
                    <p className={classNames('btn--data__value')} id="wbvlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.manual.iso}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="shutter" data-position="3_2"  onClick={() => {this.selectClick(select, 'shutterspeed',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ShutterSpeed</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.manual.shutterSpeedText}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="wb" data-position="3_3"  onClick={() => {this.selectClick(select, 'wb',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>WB</p>
                    <p className={classNames('btn--data__value--icon')} id="wblabel0">
                    <p className={classNames('btn--data__value--icon',`${_options.manual.whiteBalanceIcon}`)}>
                        {`${_options.manual.whiteBalance}`}
                    </p>
                    </p>
                    </div>
                  </button>
                </div>
             </div>}
             {// eslint-disable-next-line
             _options.exposureProgram == '1' && version == 'YN' &&
             <div>
                 {select === 'aperture' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position4_1')} id="ap_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'iso' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position4_2')} id="iso_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)} />
                  </div>
                 }
                 {select === 'shutterspeed' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position4_3')} id="sp_menu">
                  <ThetaSwiper select={`${select}`}  options={options} updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                 {select === 'wb' && open &&
                  <div className={classNames('pluginctrl__shoot__setting__detail','show','position4_4')} id="wb_menu">
                  <ThetaSwiper select={`${select}`} options={options}  updateState={this.updateState.bind(this)}/>
                  </div>
                 }
                <div className={classNames('pluginctrl__shoot__setting','pluginctrl__shoot__setting-auto')} id="shoot__setting-auto">
                  <button disabled={disabled} className={classNames('btn','btn--data')} data-setting="shutter" data-position="4_1"  onClick={() => {this.selectClick(select, 'aperture',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>apature</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${'F' + _options.manual.aperture}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="iso" data-position="4_2" onClick={() => {this.selectClick(select, 'iso',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ISO</p>
                    <p className={classNames('btn--data__value')} id="wbvlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.manual.iso}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="shutter" data-position="4_3"  onClick={() => {this.selectClick(select, 'shutterspeed',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>ShutterSpeed</p>
                    <p className={classNames('btn--data__value')} id="evlavel1">
                        <p className={classNames('btn--data__value')}>
                        {`${_options.manual.shutterSpeedText}`}
                        </p>
                    </p>
                    </div>
                  </button>
                  <button disabled={disabled} raised  className={classNames('btn','btn--data')} data-setting="wb" data-position="4_4"  onClick={() => {this.selectClick(select, 'wb',open)}}>
                    <div>
                    <p className={classNames('btn--data__key')}>WB</p>
                    <p className={classNames('btn--data__value--icon')} id="wblabel0">
                    <p className={classNames('btn--data__value--icon',`${_options.manual.whiteBalanceIcon}`)}>
                        {`${_options.manual.whiteBalance}`}
                    </p>
                    </p>
                    </div>
                  </button>
                </div>
             </div>}
            </div>
            );
        })()}
        </div>
        );
    }
}

export default withStyles(styles)(ThetaImageMenu);



// WEBPACK FOOTER //
// ./src/components/shooting/ThetaImageMenu.js